import { render, staticRenderFns } from "./Signature.vue?vue&type=template&id=5e18a12d&scoped=true"
import script from "./Signature.vue?vue&type=script&lang=js"
export * from "./Signature.vue?vue&type=script&lang=js"
import style0 from "./Signature.vue?vue&type=style&index=0&id=5e18a12d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e18a12d",
  null
  
)

export default component.exports